module.exports = __webpack_public_path__ + "static/media/circle-white.4563e366.svg";